import { useLogin, /*useNotify,*/ Notification } from "react-admin";
import { Container, Typography, Link } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import {
  TextField,
  Button,
  Box,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { useState } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { usePopup } from "react-hook-popup";
import sfLogo from "../assets/icons/logologin.png";
import theme from "../theme";
import { makeStyles } from "@material-ui/styles";
import SimplePopupDialog from "../components/SimplePopupDialog";
import ResetPasswordDialog from "../components/ResetPasswordDialog";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.lightGray2,
    borderColor: "transparent",
    display: "grid",
    placeItems: "center",
  },
}));
const LoginPage = () => {
  const doLogin = useLogin();
  const classes = useStyles();
  const history = useHistory();
  //const notify = useNotify();
  const [showAlert] = usePopup("alert", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      error={true}
    />
  ));
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const handleSigninButton = () => {
    doLogin({ username, password }, "/").catch(() => {
      return showAlert({
        title: "Login Failed",
        message: "Wrong username or password",
      });
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.allContainer}>
        <Box
          width={"100%"}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              backgroundColor: "white",
              borderRadius: 8,
              width: 458,
              height: 585,
            }}
          >
            <Container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={sfLogo}
                alt="sflogo"
                style={{
                  width: 200,
                  height: 86,
                  marginTop: 105,
                }}
              />

              <Typography
                style={{
                  fontSize: 14,
                  color: "#FA9917",
                  marginTop: 70,

                  width: 352,
                  boxSizing: "border-box",
                }}
                align="left"
              >
                Welcome {process.env.REACT_APP_SHOP_NAME}, Please Sign in
              </Typography>

              <TextField
                id="standard-basic"
                placeholder="Username"
                style={{
                  marginTop: 10,
                  boxSizing: "border-box",
                  width: 352,
                }}
                variant="outlined"
                onChange={(e) => setUsername(e.target.value)}
              />
              <br />
              <TextField
                id="standard-basic"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                style={{
                  boxSizing: "border-box",
                  width: 352,
                }}
                variant="outlined"
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Authorize code"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                variant="contained"
                color="primary"
                style={{
                  marginTop: 34,

                  boxSizing: "border-box",
                  width: 352,
                  height: 49,
                }}
                onClick={() => handleSigninButton()}
              >
                Sign in
              </Button>

              <Link
                style={{
                  alignSelf: "flex-end",
                  marginRight: 24,
                  marginTop: 10,
                  fontFamily: "roboto",
                  fontSize: "14px",
                }}
                onClick={() => history.push({ pathname: "/forgot-password" })}
              >
                Forgot password?
              </Link>
            </Container>
          </Box>
          <ResetPasswordDialog
            open={showReset}
            onClose={() => setShowReset(false)}
          />
          <Notification />
        </Box>
      </Box>
    </ThemeProvider>
  );
};
export default LoginPage;
